/**
 * Header & Mobile Navigation Module
 */
(function() {
  'use strict';

  function initHeader() {
    const header = document.getElementById('site-header');
    const toggleBtn = document.getElementById('mobile-menu-toggle');
    const drawer = document.getElementById('mobile-drawer');
    const openIcon = toggleBtn ? toggleBtn.querySelector('.menu-open-icon') : null;
    const closeIcon = toggleBtn ? toggleBtn.querySelector('.menu-close-icon') : null;

    if (!header) return;

    // Scroll state handler
    function handleScroll() {
      if (window.scrollY > 20) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    // Mobile Drawer Toggle
    if (toggleBtn && drawer) {
      function toggleMenu(isOpen) {
        const expanded = typeof isOpen === 'boolean' ? isOpen : toggleBtn.getAttribute('aria-expanded') !== 'true';
        toggleBtn.setAttribute('aria-expanded', expanded.toString());
        drawer.setAttribute('aria-hidden', (!expanded).toString());

        if (expanded) {
          drawer.classList.add('is-open');
          document.body.classList.add('overflow-hidden');
          document.documentElement.classList.add('overflow-hidden');
          if (openIcon) openIcon.classList.add('hidden');
          if (closeIcon) closeIcon.classList.remove('hidden');
        } else {
          drawer.classList.remove('is-open');
          document.body.classList.remove('overflow-hidden');
          document.documentElement.classList.remove('overflow-hidden');
          if (openIcon) openIcon.classList.remove('hidden');
          if (closeIcon) closeIcon.classList.add('hidden');
        }
      }

      toggleBtn.addEventListener('click', function() {
        toggleMenu();
      });

      // Close mobile drawer when clicking anchor links
      const mobileLinks = drawer.querySelectorAll('a');
      mobileLinks.forEach(function(link) {
        link.addEventListener('click', function() {
          toggleMenu(false);
        });
      });

      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && toggleBtn.getAttribute('aria-expanded') === 'true') {
          toggleMenu(false);
          toggleBtn.focus();
        }
      });
    }

    // Scroll to Top Button
    const scrollTopBtn = document.getElementById('scroll-to-top');
    if (scrollTopBtn) {
      function checkScrollTop() {
        if (window.scrollY > 350) {
          scrollTopBtn.classList.remove('opacity-0', 'translate-y-6', 'pointer-events-none');
          scrollTopBtn.classList.add('opacity-100', 'translate-y-0', 'pointer-events-auto');
        } else {
          scrollTopBtn.classList.add('opacity-0', 'translate-y-6', 'pointer-events-none');
          scrollTopBtn.classList.remove('opacity-100', 'translate-y-0', 'pointer-events-auto');
        }
      }

      window.addEventListener('scroll', checkScrollTop, { passive: true });
      checkScrollTop();

      scrollTopBtn.addEventListener('click', function() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  }

  window.GinaHeader = { init: initHeader };
})();
